import { AppProvider } from './providers';
import '@/i18n';

export const App = () => <AppProvider />;
